/* hardik js */
$( document ).ready(function() {
  
  $(document).on('click', '.categories-item .title-icon', function() {
    $(this).toggleClass('active').parent('.categories-item').toggleClass('opened').siblings('.categories-item').removeClass('opened').children('.title-icon').removeClass('active');
    $(this).next('.categories-content').slideToggle(300).parent('.categories-item').siblings('.categories-item').children('.categories-content').slideUp(300);
  });
  
  
  $(document).on('keyup', '#faq-search', function () {
    var filter = $(this).val(),
        count = 0;

    $('.qa-empty-text').hide();
    $('.categories-item').each(function () {
      if(filter == '') {
        $(this).show();
      } else if ($(this).text().search(new RegExp(filter, 'i')) < 0) {
        $(this).hide();
        if ($('.categories-item:visible').length == 0) {
          $('.qa-empty-text').show();
        } else {
          $('.qa-empty-text').hide();
        }
        $('.multiple-answers').each(function() {
          if ($(this).find('.categories-item:visible').length == 0) {
            $(this).find('.categories-item').show();
          }
        });
      } else {
        $(this).show();
      }
    });
  });
});